const CheckedConfirmedUserIcon = ({fill}) => {
  return(
      <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
          <path fillRule="evenodd" clipRule="evenodd" d="M9 18C13.9705 18 18 13.9705 18 9C18 4.02943 13.9705 0 9 0C4.02943 0 0 4.02943 0 9C0 13.9705 4.02943 18 9 18ZM13.2364 7.83639C13.5878 7.48494 13.5878 6.91508 13.2364 6.5636C12.8849 6.21213 12.3151 6.21213 11.9636 6.5636L8.1 10.4272L6.9364 9.26361C6.58492 8.91216 6.01508 8.91216 5.6636 9.26361C5.31213 9.61506 5.31213 10.1849 5.6636 10.5364L7.46361 12.3364C7.81506 12.6878 8.38494 12.6878 8.73639 12.3364L13.2364 7.83639Z"
                fill={fill}/>
      </svg>
  )
}

export default CheckedConfirmedUserIcon;